import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface HomeNavbarProps {
  language: string;
  setLanguage: (lang: string) => void;
}

const HomeNavbar = ({ language, setLanguage }: HomeNavbarProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showMenuChoice, setShowMenuChoice] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLanguageChange = () => {
    setLanguage(language === "fr" ? "en" : "fr");
    setIsOpen(false);
  };

  const handleMenuClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowMenuChoice(true);
  };

  const handleMenuChoice = (type: string) => {
  setShowMenuChoice(false);
  setIsOpen(false); // ✅ Ferme le menu mobile
  if (type === "brunch") {
    navigate("/Entrees"); // ✅ Redirection brunch
  } else {
    navigate("/EntreesDinner"); // ✅ Redirection dinner
  }
};



  const navLinks = [
    { href: "/", fr: "Accueil", en: "Home" },
    { href: "/Entrees", fr: "Menu", en: "Menu", isMenu: true },
    { href: "/Reservation", fr: "Réservation", en: "Reservation" },
    { href: "/CancelReservation", fr: "Annuler Réservation", en: "Cancel Reservation" },
    { href: "/about-us", fr: "À propos de nous", en: "About Us" },
  ];

  return (
    <nav className="w-full fixed top-0 z-50 bg-gradient-to-r from-green-950 via-green-950 to-green-950 shadow-md">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-6 py-2">
        <div className="text-xl font-bold text-white tracking-wide">
          Chèvrefeuille
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:flex space-x-6 items-center">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={link.isMenu ? handleMenuClick : undefined}
              className="text-white font-bold hover:text-green-300 transition cursor-pointer"
            >
              {language === "fr" ? link.fr : link.en}
            </a>
          ))}

          <button
            onClick={handleLanguageChange}
            className="bg-white  text-green-950 px-4 py-1 rounded-full hover:bg-green-300 transition"
          >
            {language === "fr" ? "EN" : "FR"}
          </button>
        </div>

        {/* Mobile icon */}
        <button
          onClick={toggleMenu}
          className="lg:hidden p-2 text-white"
          aria-label="Menu"
          aria-expanded={isOpen}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`lg:hidden overflow-hidden transition-all duration-500 ease-in-out px-6 text-white ${isOpen ? "max-h-96 opacity-100 pb-4" : "max-h-0 opacity-0"
        }`}>
        {navLinks.map((link) => (
          <a
            key={link.href}
            href={link.href}
            onClick={link.isMenu ? handleMenuClick : undefined}
            className="block mt-3 font-bold hover:text-green-300 transition cursor-pointer"
          >
            {language === "fr" ? link.fr : link.en}
          </a>
        ))}

        <button
          onClick={handleLanguageChange}
          className="bg-white font-bold text-green-950 mt-4 px-4 py-2 rounded-full hover:bg-green-300 transition w-full"
        >
          {language === "fr" ? "English" : "Français"}
        </button>
      </div>



      {/* Menu choice modal */}

      {showMenuChoice && (
        <div className="fixed inset-0 flex items-center justify-center bg-green-950 bg-opacity-60 backdrop-blur-sm z-50">
          <div className="bg-white rounded-2xl shadow-2xl text-center w-96 transform scale-100 transition-all p-8">
            <h2 className="text-2xl font-extrabold text-green-950 mb-6">
              {language === "fr" ? "Choisissez une option" : "Choose an option"}
            </h2>

            <div className="space-y-4">
              <button
                onClick={() => handleMenuChoice("brunch")}
                className="w-full py-3 rounded-full bg-gradient-to-r from-green-800 to-green-950 text-white font-semibold shadow-md hover:scale-105 hover:shadow-lg transition-transform"
              >
                {language === "fr" ? "Brunch" : "Brunch"}
              </button>
              {/* <button
                onClick={() => handleMenuChoice("dinner")}
                className="w-full py-3 rounded-full bg-gradient-to-r from-green-800 to-green-950 text-white font-semibold shadow-md hover:scale-105 hover:shadow-lg transition-transform"
              >
                {language === "fr" ? "Dîner" : "Dinner"}
              </button> */}
            </div>

            <button
              onClick={() => setShowMenuChoice(false)}
              className="mt-6 text-green-800 font-medium hover:underline transition"
            >
              {language === "fr" ? "Annuler" : "Cancel"}
            </button>
          </div>
        </div>
      )}

    </nav>
  );
};

export default HomeNavbar;
